
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import VRFServices from "../pages/vrf-services/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/vrf-services",
    element: <VRFServices />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
